<template>
  <li class="profile-nav onhover-dropdown pe-0 py-0">
    <div class="media profile-media">
      <img
        class="b-r-10"
        src="@/assets/images/dashboard/no-user.jpg"
        alt=""
      />
      <div class="media-body" style="margin-top: 6px;">
        <span>{{ vendor.name }} <i class="middle fa fa-angle-down"></i></span>
        <!-- <p class="mb-0 font-roboto">
          Admin <i class="middle fa fa-angle-down"></i>
        </p> -->
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div" style="width: 150px;">
     
      <!-- <li>
        <i class="fa fa-gear"></i> <router-link :to="{ name: 'settings' }">Settings</router-link>
      </li> -->
      <li>
        <a @click="logout"
          ><vue-feather type="log-in"></vue-feather><span>Log out</span></a
        >
      </li>
    </ul>
  </li>
</template>

<script>

  export default 
  {
    name: 'Profile',

    data() {
			return {
				
				keyword: "",
				showsearch: false,
				listing_length: 10,

				token: "",
				errors: {},

        vendor: {},
        active_page_url: null,

			};
		},

    created() {
      this.fetchProfile();
		},

    methods: {

      getToken() {
        if (localStorage.getItem('bestdeals_vendor')) {
          var bestdeals_vendor =  JSON.parse(localStorage.getItem('bestdeals_vendor'));
          // console.log(bestdeals_vendor.token);
          if(bestdeals_vendor.token) {

            this.token = bestdeals_vendor.token;
            this.user = bestdeals_vendor;

          } else {
            this.$swal("", "Failed to fetch token, please login again", "error");
            this.$router.push({ name: "login" });
          }

        } else {
          this.$swal("", "Session expired, please login again", "error");
          this.$router.push({ name: "login" });
        }
      }, 

      fetchProfile(page_url = null) {
				this.getToken();
				let url = "/vendorData" ;
				page_url = page_url || url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.vendor = responseData.vendor;
						
					})
					.catch((err) => console.log(err));
			},

      logout() 
      {
        let url = "/logout";         
        this.getToken();
        this.loading = true;
        this.$axios
        .get(url, { headers: { Authorization: "Bearer " + this.token } })
        .then((res) => {
          console.log(res);
          var responseData = res.data.data;
          console.log(responseData);

          if(localStorage.getItem('bestdeals_vendor')) {
            localStorage.removeItem("bestdeals_vendor");    
          }         
          this.$swal("", "You have been successfully logged out", "success");
          this.$router.push({ name: "login" });
        })
        .catch((error) => {
          if (error.response) {
            if(error.response.status == 422) {               
              if (error.response.data) {
                this.errors = error.response.data.message;
              } 
              this.$swal("", error.response.statusText, "error");
                        
            } else if(error.response.status == 500) {
              this.$swal("", error.response.statusText, "error");
                        
            } else {
              this.$swal("", "Something went wrong", "error");
            }
          } else {
            this.$swal("", error.message, "error");
          }
        })
        .finally(() => (this.loading = false));
      },

    },
  };
</script>
